import { CONST_ROWS_PER_PAGE_CONCILIACAO } from '@commons/consts';
import {
  // Filtros
  NEW_FILTER_CONCILIACAO_BANCARIA_PENDING,
  NEW_FILTER_CONCILIACAO_BANCARIA_SUCCESS,
  NEW_FILTER_CONCILIACAO_BANCARIA_FAILURE,
  NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_PENDING,
  NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_SUCCESS,
  NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_FAILURE,
  // OFX (compatibilidade)
  NEW_FILTER_EXTRATOS_OFX_FAILURE,
  NEW_FILTER_EXTRATOS_OFX_PENDING,
  NEW_FILTER_EXTRATOS_OFX_SUCCESS,
  NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_FAILURE,
  NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_PENDING,
  NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_SUCCESS,

  IGNORAR_TRANSACTION_CONCILIACAO_PENDING,
  IGNORAR_TRANSACTION_CONCILIACAO_SUCCESS,
  IGNORAR_TRANSACTION_CONCILIACAO_FAILURE,

  RESTAURAR_TRANSACTION_CONCILIACAO_PENDING,
  RESTAURAR_TRANSACTION_CONCILIACAO_SUCCESS,
  RESTAURAR_TRANSACTION_CONCILIACAO_FAILURE,

  UPLOAD_EXTRATOS_OFX_FAILURE,
  UPLOAD_EXTRATOS_OFX_PENDING,
  UPLOAD_EXTRATOS_OFX_SUCCESS,

  HIDE_MODAL_OFX_CONFIRMACAO,
  SHOW_MODAL_OFX_CONFIRMACAO,

  // Conciliação (Camada 3: Rastreabilidade)
  CONCILIAR_TRANSACOES_PENDING,
  CONCILIAR_TRANSACOES_SUCCESS,
  CONCILIAR_TRANSACOES_FAILURE,

  // Modal buscar lançamentos - Lançamentos Banco
  NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_PENDING,
  NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS,
  NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE,
  NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_PENDING,
  NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE,

  // Modal buscar lançamentos - Contas a Pagar
  NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_PENDING,
  NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_SUCCESS,
  NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_FAILURE,
  NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_PENDING,
  NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_FAILURE,

  // Modal buscar lançamentos - Contas a Receber
  NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_PENDING,
  NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_SUCCESS,
  NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_FAILURE,
  NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_PENDING,
  NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_FAILURE,

  // Modal buscar lançamentos - Contas Recorrentes
  NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_PENDING,
  NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS,
  NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_FAILURE,
  NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_PENDING,
  NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS,
  NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_FAILURE,

  // Resumo conciliação
  BUSCAR_RESUMO_CONCILIACAO_PENDING,
  BUSCAR_RESUMO_CONCILIACAO_SUCCESS,
  BUSCAR_RESUMO_CONCILIACAO_FAILURE,
} from './actionTypes';

const initialState = {
  // Estados de lista e filtros principais
  list: null,
  loading: false,
  filter: {
    rows: CONST_ROWS_PER_PAGE_CONCILIACAO,
    page: 0,
    where: '',
    contaBanco: null,
    abaAtiva: 'pendentes',
    tipoTransacao: null,
  },
  // Estados específicos
  loadingUpload: false,
  uploadResponse: null,
  showModalConfirmacao: false,

  // Camada 3: Rastreamento de operações de conciliação
  activeOperations: {}, // { transactionId: { requestId, startTime } }

  // Modal buscar lançamentos - Lançamentos Banco
  lancamentosBancoModal: {
    list: null,
    loading: false,
    filter: {
      rows: CONST_ROWS_PER_PAGE_CONCILIACAO,
      page: 0
    }
  },

  // Modal buscar lançamentos - Contas a Pagar
  contasPagarModal: {
    list: null,
    loading: false,
    filter: {
      rows: CONST_ROWS_PER_PAGE_CONCILIACAO,
      page: 0
    }
  },

  // Modal buscar lançamentos - Contas a Receber
  contasReceberModal: {
    list: null,
    loading: false,
    filter: {
      rows: CONST_ROWS_PER_PAGE_CONCILIACAO,
      page: 0
    }
  },

  // Modal buscar lançamentos - Contas Recorrentes
  contasRecorrentesModal: {
    list: null,
    loading: false,
    filter: {
      rows: CONST_ROWS_PER_PAGE_CONCILIACAO,
      page: 0
    }
  },

  // Resumo conciliação
  resumo: {
    dataUltimaTransacaoOFX: null,
    dataUltimaAtualizacao: null,
    saldoAgrare: 0,
    saldoTotalBanco: 0,
    saldoPendenteConciliacao: 0,
    loading: false
  },

  // Erros
  error: null,
};

function conciliacaoBancariaReducer(state = initialState, action) {
  switch (action.type) {
    // Filtros
    case NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_PENDING:
    case NEW_FILTER_CONCILIACAO_BANCARIA_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_SUCCESS:
    case NEW_FILTER_CONCILIACAO_BANCARIA_SUCCESS:
      return {
        ...state,
        list: action.list,
        filter: action.filter,
        loading: false,
        error: null,
      };
    case NEW_FILTER_NEXT_PAGE_CONCILIACAO_BANCARIA_FAILURE:
    case NEW_FILTER_CONCILIACAO_BANCARIA_FAILURE:
      return {
        ...state,
        list: null,
        loading: false,
        error: action.error,
      };

    // OFX (mantido para compatibilidade)
    case NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_PENDING:
    case NEW_FILTER_EXTRATOS_OFX_PENDING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_SUCCESS:
    case NEW_FILTER_EXTRATOS_OFX_SUCCESS:
      return {
        ...state,
        list: action.list,
        filter: action.filter,
        loading: false,
        error: null,
      };
    case NEW_FILTER_NEXT_PAGE_EXTRATOS_OFX_FAILURE:
    case NEW_FILTER_EXTRATOS_OFX_FAILURE:
      return {
        ...state,
        list: null,
        loading: false,
        error: action.error,
      };

    case IGNORAR_TRANSACTION_CONCILIACAO_PENDING:
      return {
        ...state,
        loading: true,
      };
    case IGNORAR_TRANSACTION_CONCILIACAO_SUCCESS:
    case IGNORAR_TRANSACTION_CONCILIACAO_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case RESTAURAR_TRANSACTION_CONCILIACAO_PENDING:
      return {
        ...state,
        loading: true,
      };
    case RESTAURAR_TRANSACTION_CONCILIACAO_SUCCESS:
    case RESTAURAR_TRANSACTION_CONCILIACAO_FAILURE:
      return {
        ...state,
        loading: false,
      };

    // Upload OFX
    case UPLOAD_EXTRATOS_OFX_PENDING:
      return {
        ...state,
        loadingUpload: true,
        error: null,
      };
    case UPLOAD_EXTRATOS_OFX_SUCCESS:
      return {
        ...state,
        loadingUpload: false,
        uploadResponse: action.response,
        error: null,
      };
    case UPLOAD_EXTRATOS_OFX_FAILURE:
      return {
        ...state,
        loadingUpload: false,
        uploadResponse: null,
        error: action.error,
      };

    // Modais
    case SHOW_MODAL_OFX_CONFIRMACAO:
      return {
        ...state,
        showModalConfirmacao: true,
      };
    case HIDE_MODAL_OFX_CONFIRMACAO:
      return {
        ...state,
        showModalConfirmacao: false,
        uploadResponse: null, // Limpar uploadResponse ao fechar modal
      };

    // Modal buscar lançamentos - Lançamentos Banco
    case NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_PENDING:
    case NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_PENDING:
      return {
        ...state,
        lancamentosBancoModal: {
          ...state.lancamentosBancoModal,
          loading: true
        }
      };

    case NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS:
    case NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_SUCCESS:
      const lancamentosBancoFilter = {
        ...action.args,
        rows: action.rows || action.args?.rows || 10,
        page: action.page !== undefined ? action.page : (action.args?.page || 0)
      };

      return {
        ...state,
        lancamentosBancoModal: {
          ...state.lancamentosBancoModal,
          loading: false,
          list: action.response,
          filter: lancamentosBancoFilter
        }
      };

    case NEW_FILTER_NEXT_PAGE_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE:
    case NEW_FILTER_LANCAMENTOS_BANCO_CONCILIACAO_FAILURE:
      return {
        ...state,
        lancamentosBancoModal: {
          ...state.lancamentosBancoModal,
          loading: false
        }
      };

    // Modal buscar lançamentos - Contas a Pagar
    case NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_PENDING:
    case NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_PENDING:
      return {
        ...state,
        contasPagarModal: {
          ...state.contasPagarModal,
          loading: true
        }
      };

    case NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_SUCCESS:
    case NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_SUCCESS:
      return {
        ...state,
        contasPagarModal: {
          ...state.contasPagarModal,
          loading: false,
          list: action.response,
          filter: {
            ...action.args,
            rows: action.rows || action.args?.rows || 10,
            page: action.page !== undefined ? action.page : (action.args?.page || 0)
          }
        }
      };

    case NEW_FILTER_NEXT_PAGE_CONTAS_PAGAR_CONCILIACAO_FAILURE:
    case NEW_FILTER_CONTAS_PAGAR_CONCILIACAO_FAILURE:
      return {
        ...state,
        contasPagarModal: {
          ...state.contasPagarModal,
          loading: false
        }
      };

    // Modal buscar lançamentos - Contas a Receber
    case NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_PENDING:
    case NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_PENDING:
      return {
        ...state,
        contasReceberModal: {
          ...state.contasReceberModal,
          loading: true
        }
      };

    case NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_SUCCESS:
    case NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_SUCCESS:
      return {
        ...state,
        contasReceberModal: {
          ...state.contasReceberModal,
          loading: false,
          list: action.response,
          filter: {
            ...action.args,
            rows: action.rows || action.args?.rows || 10,
            page: action.page !== undefined ? action.page : (action.args?.page || 0)
          }
        }
      };

    case NEW_FILTER_NEXT_PAGE_CONTAS_RECEBER_CONCILIACAO_FAILURE:
    case NEW_FILTER_CONTAS_RECEBER_CONCILIACAO_FAILURE:
      return {
        ...state,
        contasReceberModal: {
          ...state.contasReceberModal,
          loading: false
        }
      };

    // Modal buscar lançamentos - Contas Recorrentes
    case NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_PENDING:
    case NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_PENDING:
      return {
        ...state,
        contasRecorrentesModal: {
          ...state.contasRecorrentesModal,
          loading: true
        }
      };

    case NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS:
    case NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_SUCCESS:
      return {
        ...state,
        contasRecorrentesModal: {
          ...state.contasRecorrentesModal,
          loading: false,
          list: action.response,
          filter: {
            ...action.args,
            rows: action.rows || action.args?.rows || 10,
            page: action.page !== undefined ? action.page : (action.args?.page || 0)
          }
        }
      };

    case NEW_FILTER_NEXT_PAGE_CONTAS_RECORRENTES_CONCILIACAO_FAILURE:
    case NEW_FILTER_CONTAS_RECORRENTES_CONCILIACAO_FAILURE:
      return {
        ...state,
        contasRecorrentesModal: {
          ...state.contasRecorrentesModal,
          loading: false
        }
      };

    // Resumo conciliação
    case BUSCAR_RESUMO_CONCILIACAO_PENDING:
      return {
        ...state,
        resumo: {
          ...state.resumo,
          loading: true
        }
      };

    case BUSCAR_RESUMO_CONCILIACAO_SUCCESS:
      return {
        ...state,
        resumo: {
          dataUltimaTransacaoOFX: action.response.dataUltimaTransacaoOFX || null,
          dataUltimaAtualizacao: action.response.dataUltimaAtualizacao || null,
          saldoAgrare: action.response.saldoAgrare || 0,
          saldoTotalBanco: action.response.saldoTotalBanco || 0,
          saldoPendenteConciliacao: action.response.saldoPendenteConciliacao || 0,
          loading: false
        }
      };

    case BUSCAR_RESUMO_CONCILIACAO_FAILURE:
      return {
        ...state,
        resumo: {
          ...state.resumo,
          loading: false
        }
      };

    // Camada 3: Rastreabilidade de operações de conciliação
    case CONCILIAR_TRANSACOES_PENDING:
      return {
        ...state,
        loading: true,
        activeOperations: {
          ...state.activeOperations,
          [action.transactionId]: {
            requestId: action.requestId,
            startTime: Date.now()
          }
        }
      };

    case CONCILIAR_TRANSACOES_SUCCESS:
    case CONCILIAR_TRANSACOES_FAILURE:
      const { [action.transactionId]: removed, ...remainingOps } = state.activeOperations;
      return {
        ...state,
        loading: false,
        activeOperations: remainingOps
      };

    default:
      return state;
  }
}

export { conciliacaoBancariaReducer };
